"use strict";
/**
 * Draft Review API Types
 *
 * Request/response types for the draft pattern review invitation system.
 * Allows pattern owners to invite reviewers to preview their drafts before publishing.
 */
Object.defineProperty(exports, "__esModule", { value: true });
